import { ImageTemplate } from 'types/ImageTemplates';

const ImageTemplatesUtil = {
  formatToWatermarks(templates: ImageTemplate | ImageTemplate[]) {
    const imageTemplates = Array.isArray(templates) ? templates : [templates];

    return imageTemplates.flatMap((template) =>
      template.image
        ? [{ url: template.image.lightbox.src, label: template.name }]
        : [],
    );
  },
};

export default ImageTemplatesUtil;
